export class NetworkError extends Error {
	constructor(error: any) {
		super(error);
	}
}
